<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100 sdcCardItem">
        <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
            <div class="row pt-3">
                <div class="col-lg-2 col-md-12 col-xs-12 col-sm-6" *ngIf="btnExcluir">
                    <button mat-flat-button color="warn" (click)="delete()" class="sdcBtnSize" matTooltip="Excluir">
                        <i class="fa fa-minus fa-1x btnIcon"></i> Excluir
                    </button>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Controle de caixa - {{hintNumber}}
                            ({{hintContrSecEx}}) </mat-label>
                        <input matInput id="txtCtrlCaixa" #txtCtrlCaixa maxlength="80" formControlName="controle_caixa"
                            name="txtCtrlCaixa" readonly class="InputBlockColor">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintControle}}
                        </mat-hint>
                        <mat-hint align="end">{{txtCtrlCaixa.value.length}} / 80</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.controle_caixa)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Número da Caixa</mat-label>
                        <input matInput id="txtNumeroCaixa" #txtNumeroCaixa maxlength="10"
                            formControlName="numero_da_caixa" placeholder="NAO INFORMADO" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                        </mat-hint>
                        <mat-hint align="end">{{txtNumeroCaixa.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.numero_da_caixa)}}</mat-error>
                    </mat-form-field>
                </div>


                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Início Pesagem Data
                        </mat-label>
                        <input matInput id="txtPesagemData" #txtPesagemData maxlength="10" mask="d0/M0/0000"
                            formControlName="Inicio_pesagem_data" [dropSpecialCharacters]="false"
                            (blur)="makeCalculations()">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                        </mat-hint>
                        <mat-hint align="end">{{txtPesagemData.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_pesagem_data)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Início Pesagem Hora
                        </mat-label>
                        <input matInput id="txtPesagemHora" #txtPesagemHora maxlength="5" mask="Hh:m0"
                            formControlName="Inicio_pesagem_hora" (blur)="makeCalculations()">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                        </mat-hint>
                        <mat-hint align="end">{{txtPesagemHora.value.length}} / 5</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_pesagem_hora)}}</mat-error>
                    </mat-form-field>
                </div>




            </div>
            <div class="row pt-3">
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Peso Tara {{hintKg}}</mat-label>
                        <input matInput id="txtPesoTara" #txtPesoTara maxlength="10" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 2 }" formControlName="Peso_tara"
                            (blur)="calcPesoLiquido()">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                        </mat-hint>
                        <mat-hint align="end">{{txtPesoTara.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.Peso_tara)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Peso Bruto {{hintKg}}</mat-label>
                        <input matInput id="txtPesoBruto" #txtPesoBruto maxlength="10" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 2 }" formControlName="Peso_bruto"
                            (blur)="calcPesoLiquido()">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                        </mat-hint>
                        <mat-hint align="end">{{txtPesoBruto.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.Peso_bruto)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Peso Líquido {{hintKg}}</mat-label>
                        <input matInput id="txtPesoLiquido" #txtPesoLiquido maxlength="20" readonly
                            formControlName="Peso_liquido" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                        </mat-hint>
                        <mat-hint align="end">{{txtPesoLiquido.value.length}} / 20</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.Peso_liquido)}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Término da Pesagem Data
                        </mat-label>
                        <input matInput id="txtTerminoPesagemData" #txtTerminoPesagemData maxlength="10"
                            mask="d0/M0/0000" formControlName="Termino_pesagem_data" (blur)="makeCalculations()">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                        </mat-hint>
                        <mat-hint align="end">{{txtTerminoPesagemData.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.Termino_pesagem_data)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Término da Pesagem Hora
                        </mat-label>
                        <input matInput id="txtTerminoPesagemHora" #txtTerminoPesagemHora maxlength="5" mask="Hh:m0"
                            formControlName="Termino_pesagem_hora" (blur)="makeCalculations()">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                        </mat-hint>
                        <mat-hint align="end">{{txtTerminoPesagemHora.value.length}} / 5</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.Termino_pesagem_hora)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Famílias Recebidas</mat-label>
                        <input matInput id="txtFamiliaRecebida" #txtFamiliaRecebida maxlength="5"
                            formControlName="Familias_recebidas" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">
                        </mat-hint>
                        <mat-hint align="end">{{txtFamiliaRecebida.value.length}} / 5</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.Familias_recebidas )}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Altura da Camada(%)</mat-label>
                        <mat-select formControlName="Altura_camada" disableCenteringOption>
                            <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                                (keyup)="createFilterAlturaCamada($event.target.value)">
                            <mat-option *ngFor="let item of listAlturaCamada" [value]="item.name">
                                {{item.name | uppercase}}
                            </mat-option>
                        </mat-select>
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>

                        <mat-error>{{hasErrorFormControl(formulario.controls.Altura_camada )}}</mat-error>
                    </mat-form-field>
                </div>


            </div>

        </form>
    </div>
</div>